module.exports = __webpack_public_path__ + "static/media/trash.665926e2.svg";